import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW"; 

export default function FechGetSparingpartnerBySlug(slug) {
 
  var url = "/sparingpartner/" + slug;

  return FetchGetDataWithAuthNEW(url);
}